import { SchemaGetter } from "effect";
import { Schema as S } from "effect";

const AddressSchema = S.Struct({
  kind: S.String,
  street: S.optional(S.String),
  houseno: S.optional(S.String),
  zip: S.optional(S.String),
  city: S.optional(S.String),
  countryCode: S.optional(S.String),
  country: S.optional(S.String),
  _id: S.optional(S.String),
});

const InsuranceStatusSchema = S.Struct({
  type: S.String,
  insuranceNo: S.optional(S.String),
  insuranceName: S.optional(S.String),
  insurancePrintName: S.optional(S.String),
  insuranceId: S.optional(S.String),
  cardSwipe: S.optional(S.String),
});

const MatchedPatientSchema = S.Struct({
  _id: S.String,
  addresses: S.optional(S.Array(AddressSchema)),
  firstname: S.optional(S.String),
  lastname: S.optional(S.String),
  kbvDob: S.optional(S.String),
  insuranceStatus: S.optional(S.Array(InsuranceStatusSchema)),
  dob: S.optional(S.String),
  talk: S.optional(S.String),
  gender: S.optional(S.String),
  patientNo: S.optional(S.String),
});

const DiffItemSchema = S.Struct({
  aVal: S.optional(S.Unknown),
  bVal: S.optional(S.Unknown),
  type: S.optional(S.String),
  changed: S.optional(S.Boolean),
  label: S.optional(S.String),
  path: S.optional(S.String),
  parentPath: S.optional(S.String),
  parentPathLabel: S.optional(S.String),
  index: S.optional(S.Number),
  isEnum: S.optional(S.Boolean),
});

const DataSchema = S.Struct({
  crlogId: S.String,
  status: S.String,
  validationStatus: S.String,
  possibleActions: S.Array(S.String),
  _id: S.optional(S.String),
  firstname: S.optional(S.String),
  lastname: S.optional(S.String),
  gender: S.optional(S.String),
  talk: S.optional(S.String),
  kbvDob: S.optional(S.String),
  addresses: S.optional(S.Array(AddressSchema)),
  insuranceStatus: S.optional(S.Array(InsuranceStatusSchema)),
  dob: S.optional(S.String),
  countryMode: S.optional(S.Array(S.String)),
  matchedPatients: S.optional(S.Union([S.Array(MatchedPatientSchema), S.Literal("").pipe(S.decodeTo(S.Array(MatchedPatientSchema), {  decode: SchemaGetter.transform(() => []), encode: SchemaGetter.transform(() => "" as const) }))])),
  diff: S.optional(S.Array(DiffItemSchema)),
});

// The SDK client unwraps the vendor `{ meta, data }` envelope and raises
// `meta.errors` as exceptions, so this schema describes the payload (`data`).
export const ApplyActionResponseSchema = DataSchema;

export type ApplyActionResponse = S.Schema.Type<typeof ApplyActionResponseSchema>;
